import { render, staticRenderFns } from "./eatTime.vue?vue&type=template&id=3f5ff7d4&scoped=true&"
import script from "./eatTime.vue?vue&type=script&lang=js&"
export * from "./eatTime.vue?vue&type=script&lang=js&"
import style0 from "./eatTime.vue?vue&type=style&index=0&id=3f5ff7d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5ff7d4",
  null
  
)

export default component.exports